import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { DEFAULT_KEY_BINDINGS } from '@/core/constants'
import { loadSettings, saveSettings } from '@/systems/persistence'
import type { KeyBindings, QualityTier, SceneId, UserSettings } from '@/core/types'

interface AppState {
  // 场景
  currentScene: SceneId
  goToScene: (scene: SceneId) => void

  // 设置（已持久化）
  settings: UserSettings
  setQuality: (tier: QualityTier) => void
  updateSettings: (patch: Partial<UserSettings>) => void

  // 键位
  keyBindings: KeyBindings

  // 运行时（不持久化）
  loading: boolean
  setLoading: (v: boolean) => void
  fps: number
  setFps: (v: number) => void
}

export const useAppStore = create<AppState>()(
  subscribeWithSelector((set) => ({
    currentScene: 'menu',
    goToScene: (scene) => set({ currentScene: scene }),

    settings: loadSettings(),
    setQuality: (tier) =>
      set((s) => {
        const next = { ...s.settings, quality: tier }
        saveSettings(next)
        return { settings: next }
      }),
    updateSettings: (patch) =>
      set((s) => {
        const next = { ...s.settings, ...patch }
        saveSettings(next)
        return { settings: next }
      }),

    keyBindings: DEFAULT_KEY_BINDINGS,

    loading: false,
    setLoading: (v) => set({ loading: v }),
    fps: 60,
    setFps: (v) => set({ fps: v }),
  })),
)
